import React, { useState } from 'react';
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle
} from '@mui/material'
import { useTranslation } from 'react-i18next';
import { encodeBase64UUID } from '../../security/encdec64';

export default function SupportDialog({
    company,
    seat,
    isOpen,
    openDialog,
    closeDialog
}) {
    const {t} = useTranslation();
    const [assist, setAssist] = useState(false);

    const handleClickYes = async () => {
        try {

          const response = await fetch(`${process.env.REACT_APP_API_URL}/public/restaurant/${encodeBase64UUID(company._id)}/help/${encodeBase64UUID(seat._id)}`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ message: `${t('requestAssistance')} ${seat.label}` })
          });
          if (response.ok) {
              setAssist(true);

              setTimeout(() => {
                setAssist(false);
            }, 5 * 60 * 1000); // 5 minutes in milliseconds
          }
      }
      catch (error) {
          console.error(error);
      }
    }

    return (
        <Dialog
          open={isOpen('support')}
          onClose={() => closeDialog('support')}
          keepMounted
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description">
        <DialogTitle id="alert-dialog-title">
            {t('helpTitle')}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {!assist ? t('helpRequestMessage') : t('helpConfirmMessage')}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          {!assist ? (
            <>
              <Button
                      sx={{color: '#4B7359'}}
                      onClick={() => closeDialog('support')}>
                {t('helpNoButton')}
              </Button>
              <Button
                      sx={{color: '#4B7359'}}
                      onClick={handleClickYes}>
                {t('helpYesButton')}
              </Button>
            </>
          ) : (
              <Button
                sx={{color: '#4B7359'}}
                onClick={() => closeDialog('support')}>
              {t('helpOkButton')}
            </Button>)
          }
        </DialogActions>
      </Dialog>
    );
}
